export default class URLIterator implements Iterator<string> {
    private pointer = 0;

    constructor(public urls: string[]) {}

    public next(): IteratorResult<string> {
        if (this.pointer < this.urls.length) {
            return {
                done: false,
                value: this.urls[this.pointer++]
            };
        } else {
            return {
                done: true,
                value: ''
            };
        }
    }

    public current(): IteratorResult<string> {
        if(this.pointer>0){
            return {
                done: false,
                value: this.urls[this.pointer-1]
            };
        } else {
            return {
                done: true,
                value: ''
            };
        }
    }

    public restart(): void {
        this.pointer = 0;
    }
}